import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '../../api'
import type { MultiTenantRejectionRequest } from '../../types/multiTenantRequest'

const useRejectMultiTenantRequest = (
	clusterId: string,
	multiTenantRequestID: string
) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (rejection: MultiTenantRejectionRequest) =>
			api.multiTenantRequests.rejectMultiTenantRequest(rejection),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['multiTenantRequests', clusterId]
			})
			queryClient.invalidateQueries({
				queryKey: ['multiTenantRequest', multiTenantRequestID]
			})
		}
	})
}

export default useRejectMultiTenantRequest
